const scrollPositionStorageKey = 'press-page-scroll-position';

const restoreScrollPosition = (): void => {
    const savedScrollPosition = sessionStorage.getItem(scrollPositionStorageKey);

    if (!savedScrollPosition) {
        return;
    }

    sessionStorage.removeItem(scrollPositionStorageKey);

    requestAnimationFrame(() => {
        window.scrollTo({
            top: parseInt(savedScrollPosition, 10),
            behavior: 'auto'
        });
    });
}

const initializeShowMoreButton = (): void => {
    const showMoreButton = document.querySelector('.press-page__show-more-button') as HTMLAnchorElement | null;

    if (!showMoreButton) {
        return;
    }

    showMoreButton.addEventListener('click', () => {
        sessionStorage.setItem(scrollPositionStorageKey, window.scrollY.toString());
    });
}

const usePressPage = (filterElement: HTMLDivElement): void => {
    const selectElement = filterElement.querySelector(".press-page__year-select") as HTMLSelectElement;

    /* Initialize and add event listeners */
    const initialize = (): void => {
        selectElement.addEventListener('change', () => {
            location.href = "?year=" + selectElement.value;
        });

        initializeShowMoreButton();
    }

    initialize();
};

document.addEventListener('DOMContentLoaded', () => {
    restoreScrollPosition();

    const filterElement: HTMLDivElement | null = document.querySelector('.press-page__filter');

    if (filterElement) {
        usePressPage(filterElement);
    } else {
        initializeShowMoreButton();
    }
});
